//import { Icon } from "antd";
import React, { useEffect, useRef } from "react";
import { getIntroduction } from "../../../../api/courses";
import { MatApoyo } from "../Generals";
import { useSelector } from "react-redux";
import { nombreOPL} from "../../../Generals/autoridadesElectorales";


export default function Lesson1({ data, setLoading, objEntidad, origen }) {

  const { idEntidad, entidad } = useSelector((state) => state.entidad);
  //const [intro, setIntro] = useState({});
  //const { testimonioObservador } = intro;
  const isMounted = useRef(true);
  // let copyArray = data;
  // let array = copyArray.length && [data[0], data[1]];

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0); // para posicionar el scroll al inicio
    getIntroduction()
      .then((res) => {
        //isMounted.current && setIntro(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  /*function download(file) {
    let a = document.createElement("a"); //Create <a>
    a.href = `data:application/pdf;base64,${file}`; //Image Base64 Goes here
    a.download = `Testimonio – Informe de una observadora.pdf`; //File name Here
    a.click(); //Downloaded file
  }*/

  //función que ontiene los datos de la entidad dependiendo si se visualiza la lección dsde el curso o desde materiales de capacitación
  const getDataEntidad = () =>{
    const dataEntidad = origen === 1 ? objEntidad : {idEntidad: idEntidad, entidad: entidad};
    return dataEntidad
  }

  return (
    <>
      <p className="textoResaltado bold">
      ¡Te damos la más cordial bienvenida a tu curso “La Observación Electoral Proceso Electoral Extraordinario 2024”!   
      </p>
      <p>
      La observación electoral es una herramienta que permite a la ciudadanía contribuir activamente a la 
      integridad y la transparencia de los procesos electorales en México. A través de esta lección, 
      aprenderás cómo desempeñar este importante papel de manera efectiva y la relevancia que tiene para: 
      </p>
      <div className="listGuion"><span>Otorgar certeza en los comicios</span></div >
      <div className="listGuion"><span>Generar confianza en los resultados</span></div >
      <div className="listGuion"><span>Fomentar la participación libre y voluntaria de las y los ciudadanos,</span></div >
      <div className="listGuion"><span>Ampliar los cauces de participación ciudadana en las elecciones.</span></div >
      <br/>
      <div className="texto_parrafo">
        <p>
        <b>La observación electoral</b> es un derecho fundamental que se extiende a todas y todos los ciudadanos mexicanos, 
        tanto en el territorio nacional como en el extranjero. Este derecho permite presenciar de manera directa todos 
        los actos que conforman las diferentes etapas del proceso electoral, desde su inicio hasta su conclusión, 
        siempre y cuando cuenten con la acreditación correspondiente.
        </p>
        <p className="bold">
         Para obtener la acreditación y ser observador u observadora electoral, se deben cumplir los siguientes requisitos:
        </p>
        <div className="listPunto">Ser ciudadana o ciudadano mexicano en pleno goce de sus derechos civiles y políticos.</div>
        <div className="listPunto">No ser ni haber sido parte de dirigencias nacionales, estatales o municipales de partido político en los tres años anteriores a la elección.</div>
        <div className="listPunto">No ser ni haber sido candidato/a para un cargo de elección popular en los tres años anteriores a la elección.</div>
        <div className="listPunto">Tomar el curso de capacitación.</div>
        <div className="listPunto">No ser representante de partido político o de candidatura independiente ante la casilla.</div>
        <div className="listPunto">No haber sido designado o designada como funcionario/a de casilla.</div>
        <div className="listPunto">No ser persona servidora pública vinculada con programas sociales en el gobierno municipal, 
        estatal o federal, ni ser persona operadora de programas sociales y actividades institucionales, cualquiera que sea su denominación; 
        no ser persona servidora de la nación.<sup>1</sup></div>
        <br/>
        <p style={{fontSize: "8pt"}}><sup> 1 </sup>Artículos 10, fracción II y 17 de los Lineamientos en cumplimiento a la sentencia 
        dictada por la Sala Superior del Tribunal Electoral del Poder Judicial de la Federación en el expediente 
        SUP-RAP-04/2023 y acumulados, que establecen medidas preventivas para evitar la injerencia y/o participación 
        de personas servidoras públicas que manejan programas sociales en el Proceso Electoral Federal y los Procesos 
        Electorales Locales 2023-2024, emitidos por el Consejo General del INE mediante el Acuerdo <b>INE/CG535/2023</b>.
        </p>
        <p>
        El registro de la solicitud para ser observador u observadora electoral puede realizarse en línea a través del <b className="textoResaltado">Portal de 
        Observadoras y Observadores Electorales del INE</b>, o bien de manera presencial ante los consejos locales o distritales del 
        INE o de los Organismos Públicos Locales (OPL). Revisa el siguiente material para conocer el procedimiento de acreditación:
        </p>
        <p>
          {data && data[0] && <MatApoyo array={[data[0]]} />}
        </p>
        <p>
        La observación electoral tiene un papel crucial para garantizar la transparencia y la legitimidad de los comicios. 
        Al fomentar la confianza en los resultados electorales y promover la participación activa y libre de la ciudadanía, 
        la observación electoral también contribuye al fortalecimiento de la democracia en nuestro país.
        <br/><br/>
        En el siguiente enlace revisaremos los principios fundamentales que te guiarán como observadora u observador electoral, 
        como <b className="textoResaltado">la imparcialidad, la objetividad, la certeza, la legalidad y la ausencia de 
        vínculos partidistas.</b> 
        </p>
        <p>
        {data && data.indexOf(1) && <MatApoyo array={[data[1]]} />}
        </p>
        <p >
        En el siguiente material exploraremos los derechos y obligaciones que acompañan a esta tarea, desde la observación 
        de los actos de preparación hasta la presentación de informes sobre lo observado. 
        </p>
        <p>
        {data && data.indexOf(2) &&<MatApoyo array={[data[2]]} />}
        </p>
        <p>
        Recuerda que podrás presentar ante el INE o {nombreOPL(parseInt(getDataEntidad().idEntidad))}, dentro de los 30 días 
        siguientes a la Jornada Electoral, un informe que contenga al menos lo siguiente:
        </p>
        <div className="listPunto">Nombre de la o el ciudadano</div>
        <div className="listPunto">Nombre de la organización a la que pertenece, en su caso</div>
        <div className="listPunto">Elección que observó</div>
        <div className="listPunto">Entidad federativa, distrito local o federal, o municipio en el cual participó</div>
        <div className="listPunto">Etapas del proceso electoral en las que participó</div>
        <div className="listPunto">A cuántas y cuáles casillas acudió</div>
        <div className="listPunto">Descripción de las actividades realizadas</div>
        <br/>
        <p>
        Te invitamos a ver el siguiente video en el que repasaremos qué es la observación electoral y la gran 
        relevancia que tiene tu participación como observador u observadora dentro de este proceso electoral.
        </p>
        <p>{data && data.indexOf(3) &&<MatApoyo array={[data[3]]} />}</p>
        <p>
        A continuación, te presentamos un material de apoyo para reforzar lo que aprendiste.
        </p>
        <p>{data && data.indexOf(4) &&<MatApoyo array={[data[4]]} />}</p>
        <p>
        Para profundizar tus conocimientos sobre la observación electoral, revisa el <b className="textoResaltado2">CAPÍTULO 1 DE TU&nbsp;
        {data && data.indexOf(5) && <MatApoyo array={[data[5]]} tipo={1}/>},</b> que está disponible en los materiales de consulta de este curso.
        </p>
        <p>
        ¡Muy bien! Ahora que tienes un panorama general de la observación electoral y los principios que la rigen, 
        realiza la actividad de autoevaluación para reforzar tu aprendizaje, después podrás continuar con la siguiente 
        lección.
        </p>
      </div>
    </>
  );
}
